import { create } from 'zustand';
import { CustomerDataType, CustomerStoreType } from '@am3nd-org/pointcraft-types';

export const useCustomerStore = create<CustomerStoreType>((set, _get) => ({
  customerList: [], // Set all to empty arrays
  setCustomerList: (customerList) => {
    set((state) => ({ ...state, customerList }));
  },
  addCustomer: (customer) => {
    set((state) => ({ ...state, customerList: [...state.customerList, customer] }));
  },
  updateCustomer: (customer, identifier) => {
    set((state) => {
      const foundCustomer = state.customerList.find((cust) => cust.id === identifier);
      if (!customer) return { ...state };
      const updatedCustomer = { ...foundCustomer, ...customer } as CustomerDataType;
      // add the updated customer to the top of the list
      const filteredList = state.customerList.filter((cust) => cust.id !== identifier);
      return {
        ...state,
        customerList: [updatedCustomer, ...filteredList],
      };
    });
  },
}));

/**
 *

  const { example, exampleVar: false } = useExampleDataStore((state) => ({
    currentInventory: state.currentInventory,
    newInventory: state.newInventory,
  }));

  const setExample = useExampleDataStore.getState().setExample();

 */
